<script setup>
import emitter from "@/utils/bus"; // 通信对象
import { ref, onUnmounted } from "vue";
import { useConfigStore } from "@/store/config";
import { useI18n } from "vue-i18n";
import Loading from "@/components/Loading.vue";
import { checkStarsOrderStatus } from "@/api/order";
import { checkOrderStatusV2 } from "../api/TON";
import { checkPaymentStatus } from "../utils/common"

const { t } = useI18n();

const config = useConfigStore();
const isShow = ref(false);
const isChecking = ref(false); // 新增：检查中状态
const failCheck = ref(false); // 显示检查失败提示
const taskDetail = ref({
  name: "",
  image: "",
  reward_type: "",
  reward: 0,
});
const orderDetail = ref({
  type: "",
  order_id: "",
});

const close = () => {
  isShow.value = false;
  emitter.emit("orderTaskResult", false); // 触发任务未完成
};

// 添加检查结果处理函数
const handleCheck = async () => {
  isChecking.value = true; // 开始检查，显示加载状态
  failCheck.value = false;
  let order_status = "";
  if (orderDetail.value.type == "ton") { //检查ton
    const check_result = await checkPaymentStatus({
      back: checkOrderStatusV2,
      back_data: orderDetail.value.order_id,
      maxAwaitRetries: 2, //等待的重试次数
      maxErrorRetries: 3, //失败的重试次数
      interval: 10000, //每次检查间隔
    });
    if (check_result.success) {
      order_status = "success";
    }
  } else if (orderDetail.value.type == "stars") { //检查星星
    let res = await checkStarsOrderStatus(orderDetail.value.order_id);
    if (res.code == 200 && res.data == "success") {
      order_status = "success";
    }
  }
  // 任务完成
  if (order_status == "success") {
    emitter.emit("orderTaskResult", true);
    isShow.value = false;
  } else {
    failCheck.value = true;
  }
  // 关闭加载中
  isChecking.value = false;
};

const handleShowLoadingModal = async (res) => {
  failCheck.value = false;
  isShow.value = res.isShow;
  taskDetail.value = res.taskDetail;
  orderDetail.value = res.orderDetail;
};

emitter.on("showLoadingModal", handleShowLoadingModal);

onUnmounted(() => {
  emitter.off("showLoadingModal", handleShowLoadingModal);
});
</script>

<template>
  <Transition name="modal">
    <div class="view" v-show="isShow">
      <Transition name="modal-size">
        <div class="language" v-show="isShow">
          <img src="../assets/imgs/wrong.svg" alt="" class="close" @click="close" />
          <div class="content">
            <img :src="taskDetail.image" alt="" class="task-image" />
            <div class="desc">{{ taskDetail.name }}</div>
            <div class="reward">
              +{{ taskDetail.reward }}
              <img src="@/assets/icon/key.svg" v-if="taskDetail.reward_type == 'diamond'" />
              <img :src="config.coin_image" v-else />
            </div>

            <!-- 检查结果显示区域 -->
            <div class="result-area">
              <!-- 检查中状态 -->
              <div v-if="isChecking" class="checking">
                <Loading class="loading-icon" size="small" color="#000" />
                <span> {{ $t("message.PaymentConfirming") }}</span>
              </div>
              <!-- 检查按钮 -->
              <div class="check-btn" v-if="!isChecking" @click="handleCheck" :disabled="isChecking">
                {{ $t("message.Check") }}
              </div>
            </div>
            <div class="fail-msg" v-if="failCheck">
              {{ $t("message.CheckFail") }}
            </div>
          </div>
        </div>
      </Transition>
    </div>
  </Transition>
</template>

<style lang="scss" scoped>
/* 进入和离开动画 */
.modal-enter-active,
.modal-leave-active {
  transition: all 0.3s ease;
}

.modal-leave-to,
.modal-enter-from {
  opacity: 0;
}

.modal-enter-to,
.modal-leave-from {
  opacity: 1;
}

/* 进入和离开动画 */
.modal-size-enter-active,
.modal-size-leave-active {
  transition: all 0.3s ease;
}

.modal-size-leave-to,
.modal-size-enter-from {
  transform: scale(0.9);
}

.modal-size-enter-to,
.modal-size-leave-from {
  transform: scale(1);
}

.view {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  backdrop-filter: blur(5px);

  .language {
    width: 90vw;
    margin: 0 auto;
    background: #fff;
    display: block;
    padding: 6vw;
    border-radius: 3vw;
    border: #555 solid 1px;
    position: relative;

    .close {
      width: 6vw;
      height: 6vw;
      position: absolute;
      top: 3vw;
      right: 3vw;
    }

    .icon {
      margin-top: 8vw;
      width: 100%;
      display: flex;
      justify-content: center;
    }

    .content {
      margin-top: 8vw;
      margin-bottom: 4vw;
      color: #000;
      white-space: pre-wrap;
      text-align: center;
      font-size: 5vw;
      line-height: 7vw;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .task-image {
        height: 10vh;
        margin-bottom: 2vh;
      }

      .desc {
        // color:gold;
        font-size: 4vw;
        margin-bottom: 4vh;
      }

      .fail-msg {
        font-size: 3.5vw;
        color: #f44336;
        margin-top: 3vh;
      }

      .reward {
        // color:gold;
        font-size: 6vw;
        font-weight: bold;
        margin-bottom: 2vh;
        display: flex;
        align-items: center;

        img {
          width: 5vw;
          height: 5vw;
          margin-left: 0.5vw;
        }
      }

      button {
        background: #fff;
        border: none;
        width: 50vw;
        height: 5vh;
        border-radius: 1vh;
        font-size: 6vw;
      }

      &.time-end {
        margin: 0;
      }

      &.time {
        margin: 0;
      }

      .result-area {
        margin-top: 5vh;
        width: 100%;
        min-height: 10vh;
        display: flex;
        align-items: center;
        justify-content: center;

        .checking {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 1vh;

          .loading-icon {
            width: 6vw;
            height: 6vw;
          }

          span {
            margin-top: 1vw;
            font-size: 4vw;
            color: #999;
          }
        }

        .check-result {
          font-size: 5vw;
          margin-bottom: 2vh;

          &.success {
            color: #4caf50;
          }

          &.failed {
            color: #f44336;
          }
        }

        .check-btn {
          background: #000;
          border: none;
          width: 50vw;
          border-radius: 1vh;
          font-size: 6vw;
          font-weight: bold;
          padding: 2vh 0vw;
          color: #fff;

          &:disabled {
            opacity: 0.5;
            cursor: not-allowed;
          }
        }
      }
    }
  }
}
</style>
